import React from 'react';
import PropTypes from 'prop-types';

import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';

import { DATA_FEEDS } from './Chart';
import SelectMetrics from '../../../../../components/Selectors/SelectMetrics';
import SelectTimezone from '../../../../../components/Selectors/SelectTimezone';
import SelectRange from '../../../../../components/Selectors/SelectRange';
import {
  current,
  today,
  yesterday,
  lastMonth,
  lastWeek,
  thisMonth,
  thisWeek,
} from '../../../../../helpers/date';

export const RANGES = [
  { key: 0, label: 'Current', func: current },
  { key: 1, label: 'Today', func: today },
  { key: 2, label: 'Yesterday', func: yesterday },
  { key: 3, label: 'This Week', func: thisWeek },
  { key: 4, label: 'Last Week', func: lastWeek },
  { key: 5, label: 'This Month', func: thisMonth },
  { key: 6, label: 'Last Month', func: lastMonth },
  { key: 7, label: 'Custom Range' },
];

function ModelingChartToolbar({
  selectedMetrics,
  setSelectedMetrics,
  range,
  setRange,
  timezone,
  setTimezone,
}) {
  return (
    <Stack
      direction='row'
      alignItems='center'
      spacing={1}
      divider={<Divider orientation='vertical' flexItem sx={{ my: 0.5 }} />}
      sx={{
        px: 1.5,
        py: 0.75,
        bgcolor: 'background.paper',
        borderRadius: 1,
        boxShadow: 1,
        display: 'inline-flex',
      }}>
      <SelectMetrics
        metrics={Object.keys(DATA_FEEDS)}
        selectedMetrics={selectedMetrics}
        setSelectedMetrics={setSelectedMetrics}
      />
      <SelectRange
        ranges={RANGES}
        range={range}
        defaultRange={RANGES[0]}
        setRange={setRange}
        timezone={timezone}
      />
      <SelectTimezone
        selectedTimezone={timezone}
        setSelectedTimezone={setTimezone}
      />
    </Stack>
  );
}

ModelingChartToolbar.propTypes = {
  selectedMetrics: PropTypes.array.isRequired,
  setSelectedMetrics: PropTypes.func.isRequired,
  range: PropTypes.object.isRequired,
  setRange: PropTypes.func.isRequired,
  timezone: PropTypes.object.isRequired,
  setTimezone: PropTypes.func.isRequired,
};

export default ModelingChartToolbar;